import { lobbyStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';

class LobbyService {
  onGetInitialStateResult(data) {
    const { gameTypes, hasDemo, currencyCode, balance, rate, precision } = data;
    const { [DefaultQueryParams.CurrencySymbol]: currencySymbol, [DefaultQueryParams.UserId]: userId } = parseQuery(
      window.location.search
    );

    lobbyStore.setGameTypes(gameTypes);
    lobbyStore.setHasDemo(hasDemo);
    userInfoStore.setUserInfo({
      rate,
      precision,
      currencyCode,
      currencySymbol,
      balance,
      userId,
      demoBalance: 10000,
    });
    // loadingStore.updateLoading({ isGameInitialLoaded: false });
  }

  handleRoundFinished(data) {}

  // handleLobbyUsersCount(data) {
  //   const updatedGameTypes = lobbyStore.gameTypes.map((item) =>
  //     item.gameTypeId === data.gameTypeId
  //       ? {
  //           ...item,
  //           activeUsersCount: data.activeUsersCount,
  //         }
  //       : { ...item }
  //   );
  //   lobbyStore.setGameTypes(updatedGameTypes);
  // }

  handleReconnecting() {
    // popupStore.open({ name: PopUps.Reconnect });
  }

  handleReconnected() {
    // popupStore.close();
  }

  handleConnectionError() {
    // popupStore.open({ name: PopUps.ConnectionError });
    // popupStore.onConnectionError(true)
  }
}

export const lobbyService = new LobbyService();
